import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SERVICES } from '../data/services';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { SEOHead, ServiceSchema } from '../components/SEO';
import { SEO_KEYWORDS } from '../components/SEO';

const Services = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      <SEOHead
        title="20+ Human on Rent Services - Movies, Travel, Elder Care, Events & More | HumanOnRent.AI"
        description="Browse 20+ professional human rental services. Movies, shopping, travel, medical help, elder care, business events, sports, dinner & more. Starting Rs.1000/hr + GST."
        keywords={SEO_KEYWORDS.services}
        url="https://humanonrent.ai/services"
      />
      <ServiceSchema services={SERVICES} />
      <span className="sr-only-seo">
        boyfriend on rent services, girlfriend on rent categories, human on rent services india
      </span>

      <Header />

      <main className="pt-32 pb-20 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-light text-gray-900 leading-tight mb-6">
              Our <span className="font-medium">Services</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Choose from 20+ service categories to find your perfect partner
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {SERVICES.map((service) => {
              const Icon = service.icon;
              return (
                <div
                  key={service.id}
                  onClick={() => navigate(`/auth?service=${service.id}`)}
                  className="service-card cursor-pointer group"
                  data-testid={`service-page-${service.id}`}
                >
                  <div className={`${service.color} p-6 h-full flex flex-col items-center justify-center min-h-[180px]`}>
                    <Icon className="w-10 h-10 text-white mb-3 group-hover:scale-110 transition-transform" />
                    <span className="text-white font-medium text-center">{service.name}</span>
                    <p className="text-white/70 text-xs text-center mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                      {service.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* CTA */}
          <div className="mt-20 text-center">
            <div className="premium-card inline-block p-10 max-w-lg">
              <h3 className="text-2xl font-medium text-gray-900 mb-4">Ready to Get Started?</h3>
              <p className="text-gray-600 mb-8">
                Sign up now and find your perfect partner for any occasion
              </p>
              <button
                onClick={() => navigate('/auth')}
                className="btn-premium"
                data-testid="services-cta-btn"
              >
                Create Free Account
                <ArrowRight className="w-4 h-4 ml-2" />
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Services;
